import { Controller } from "@hotwired/stimulus"

// Кнопка «Проверить прокси» в разделе настроек: запрашивает у сервера тестовое
// обращение к OpenAI через сохранённый прокси и показывает вердикт.
export default class extends Controller {
  static values = { url: String }
  static targets = ["button", "output"]

  async test() {
    this.buttonTarget.disabled = true
    this.outputTarget.classList.remove("d-none")
    this.outputTarget.innerHTML = "<div class='text-muted'>Проверяем…</div>"

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Accept": "application/json"
        }
      })
      const data = await response.json()
      this.outputTarget.innerHTML = this.resultHtml(data)
    } catch (error) {
      this.outputTarget.innerHTML = `<div class="alert alert-danger mb-0">Ошибка запроса: ${this.escape(error.message)}</div>`
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  resultHtml(data) {
    const level = data.success ? "success" : "danger"
    const code = data.http_code ? ` <span class="badge bg-secondary">HTTP ${this.escape(String(data.http_code))}</span>` : ""

    return `
      <div class="alert alert-${level} mb-0">
        <div>${this.escape(data.message || "")}${code}</div>
        <div class="small text-muted mt-1">Маршрут: <code>${this.escape(data.proxy || "—")}</code></div>
      </div>
    `
  }

  escape(value) {
    const div = document.createElement("div")
    div.textContent = value
    return div.innerHTML
  }
}
